import React from 'react';
import PropTypes from "prop-types";
import Table from "../../../common/components/Table/Table";
import {Button, Checkbox, Modal, Popup} from "semantic-ui-react";
import { connect } from "react-redux";
import CountriesListRow from "./CountriesListRow";
import {generateKYBCountryCoverageReport} from "../../../report-generation/veritas-report-gen/ReportGeneratorActions";
import {ServiceTypes} from "../../data-services/constants/ServiceActionConstants";
import CountryForm from "../../add-edit/components/CountryForm";
import {addCountry, toggleCountryModal, validateCountryForm} from "../../add-edit/actions/AddEditCountryActions";
import {CountrySortFields} from "../constants/CountriesActionConstants";
import {countryTableSearch, toggleCountrySort} from "../actions/CountriesActions";
import {TableSearch} from "../../../common/components/TableSearch";

export class CountriesTable extends React.Component {

    static propTypes = {
        Countries: PropTypes.array,
    }

    handleCountriesSort = (sortKey) => {
        this.props.changeCountriesSort(sortKey);
    }

    handleBVReportClick = () => {
        this.props.typeBasedKYBReport(ServiceTypes.KYB_SUB_TYPE.BV);
    }

    handleKYBReportClick = () => {
        this.props.typeBasedKYBReport(ServiceTypes.KYB_SUB_TYPE.KYB);
    }

    handleODOReportClick = () => {
        this.props.typeBasedKYBReport(ServiceTypes.KYB_SUB_TYPE.ODO);
    }

    handleAllKYBReportClick = () => {
        this.props.typeBasedKYBReport(ServiceTypes.KYB_SUB_TYPE.ALL);
    }

    get pdfReports() {
        return (
            <div style={{padding: "20px 20px 0 30px"}}>
                <Popup
                    trigger={<Button
                        content={"BV"} labelPosition={"right"}
                        icon="file excel outline" size="medium" tool-tip={"BV Coverage"}
                        onClick={this.handleBVReportClick}
                    />}
                    position='bottom center'
                    content="Country Coverage Report for BV."
                />
                <Popup
                    trigger={<Button
                        content={"KYB"} labelPosition={"right"}
                        icon="file excel outline" size="medium" tool-tip={"BV Coverage"}
                        onClick={this.handleKYBReportClick}
                    />}
                    position='bottom center'
                    content="Country Coverage Report for KYB."
                />
                <Popup
                    trigger={<Button
                        content={"ODO"} labelPosition={"right"}
                        icon="file excel outline" size="medium" tool-tip={"BV Coverage"}
                        onClick={this.handleODOReportClick}
                    />}
                    position='bottom center'
                    content="Country Coverage Report for ODO."
                />
                <Popup
                    trigger={<Button
                        content={"All-KYB"} labelPosition={"right"}
                        icon="file excel outline" size="medium" tool-tip={"BV Coverage"}
                        onClick={this.handleAllKYBReportClick}
                    />}
                    position='bottom center'
                    content="Country Coverage Report for All KYB-Type Offerings."
                />
            </div>
        )
    }

    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox disabled
                />
            </Table.Header>,
            <Table.Header key="country-name" sortKey={CountrySortFields.COUNTRY_NAME}>Country Name</Table.Header>,
            <Table.Header key="kyc-support">KYC Support</Table.Header>,
            <Table.Header key="kyb-support">KYB Support </Table.Header>,
            <Table.Header key="last-updated" sortKey={CountrySortFields.LAST_UPDATED}>Last Updated</Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }

    get tableItems() {
        return this.props.Countries.map((country, idx) => (
            <CountriesListRow
                key={idx}
                countryID={country.id}
                countryName={country.country_name}
                countryISO={country.country_iso}
                kycStatus={country.kyc_status}
                kycTier={country.kyc_tier}
                number_2x2_support={country.number_2x2_support}
                ageSupport={country.age_support}
                bvSupport={country.bv_support}
                bvPlusSupport={country.bv_plus_support}
                number_1x1_match_rate={country.number_1x1_match_rate}
                number_2x2_match_rate={country.number_2x2_match_rate}
                lastUpdated={country.last_updated}
            />
        ));
    }

    handleAddCountryClick = () => {
        this.props.addCountryModal();
    }

    handleCountryCloseModal = () => {
        this.props.toggleAddCountryModal();
    }

    handleAddCountryFormSubmit = () => {
        const { countryObj, notesObj } = this.props;
        this.props.validateCountry(countryObj, notesObj);
    }

    handleCountryTableSearch = (e) => {
        this.props.typeAheadSearchCountry(e.target.value)
    }

    render() {

        return (
            <div>
                {/*Currently the report buttons will stay out because they were KYB focused.*/}
                {/*{this.pdfReports}*/}
                <div style={{padding: "20px 20px 0 30px"}}>
                    <Button
                        icon="file excel outline" size="big"
                        disabled
                    />
                    <Button
                        style={{float: "right"}}
                        color="blue"
                        icon="add"
                        content="Add a new Country"
                        onClick={this.handleAddCountryClick}
                    />
                </div>
                <div className="data-services-list-container">
                    <TableSearch
                        handleSearch={this.handleCountryTableSearch}
                    />
                    <div className="sticky-table-container">
                        <Table
                            className="sticky-table sortable"
                            currSortKey={this.props.countriesSortKey}
                            sortDirection={this.props.countriesSortDirection}
                            headers={this.tableHeaders}
                            onSort={this.handleCountriesSort}
                        >
                            {this.tableItems}
                        </Table>
                    </div>
                </div>


                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.toggleModal}
                >
                    <Modal.Header>
                        {"Add a New Country"}
                    </Modal.Header>
                    <Modal.Content>
                        <CountryForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCountryCloseModal}
                        >
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleAddCountryFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_countries: state.veritas.countries.all_countries,
    filtered_all_countries: state.veritas.countries.filtered_all_countries,
    countriesSortKey: state.veritas.countries.countriesSortKey,
    countriesSortDirection: state.veritas.countries.countriesSortDirection,
    countryObj: state.veritas.addEdit.addEditCountry.countryObject,
    notesObj: state.veritas.addEdit.addEditCountry.notesObject,
    toggleModal: state.veritas.addEdit.addEditCountry.toggleModal
});

const mapDispatchToProps = dispatch => ({
    typeBasedKYBReport: (type) => {dispatch(generateKYBCountryCoverageReport(type))},
    addCountryModal: () => {dispatch(addCountry())},
    toggleAddCountryModal: () => {dispatch(toggleCountryModal())},
    validateCountry: (countryObj, notesObj) => {dispatch(validateCountryForm(countryObj, notesObj))},
    changeCountriesSort: (sortKey) => {dispatch(toggleCountrySort(sortKey))},
    typeAheadSearchCountry: (value) => {dispatch(countryTableSearch(value))}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CountriesTable)
